import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useCompetitorOptions = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('all'),
        value: 'All',
      },
      {
        label: t('broad'),
        value: 'Broad',
      },
      {
        label: t('narrow'),
        value: 'Narrow',
      },
    ],
    [t],
  );
};

export default useCompetitorOptions;
